import type { ApiClient } from "@/api/client";
import { API_VERSION_PREFIX } from "@/api/client";
import type {
  AnalyticsDto,
  DashboardDto,
  MarketplaceDto,
  RequestMeta,
  SystemDto,
} from "./types";

const BASE = `${API_VERSION_PREFIX}/hq/insights`;

export type InsightRange = 7 | 30 | 90 | 180 | 365;

export const INSIGHT_RANGES: { value: InsightRange; label: string }[] = [
  { value: 7, label: "Last 7 days" },
  { value: 30, label: "Last 30 days" },
  { value: 90, label: "Last 90 days" },
  { value: 180, label: "Last 6 months" },
  { value: 365, label: "Last 12 months" },
];

export function createInsightsApi(client: ApiClient) {
  return {
    async dashboard(days: InsightRange): Promise<DashboardDto> {
      const body = await client.get<{ dashboard: DashboardDto; meta: RequestMeta }>(
        `${BASE}/dashboard?days=${days}`,
      );
      return body.dashboard;
    },
    async analytics(days: InsightRange): Promise<AnalyticsDto> {
      const body = await client.get<{ analytics: AnalyticsDto; meta: RequestMeta }>(
        `${BASE}/analytics?days=${days}`,
      );
      return body.analytics;
    },
    async marketplace(days: InsightRange): Promise<MarketplaceDto> {
      const body = await client.get<{ marketplace: MarketplaceDto; meta: RequestMeta }>(
        `${BASE}/marketplace?days=${days}`,
      );
      return body.marketplace;
    },
    async system(): Promise<SystemDto> {
      const body = await client.get<{ system: SystemDto; meta: RequestMeta }>(`${BASE}/system`);
      return body.system;
    },
  };
}

export type InsightsApi = ReturnType<typeof createInsightsApi>;
